<template>
  <div>
    <p>{{ $t("节点配置") }}</p>
    <t-form-item
      name="routePolicy"
      :rules="requireRule"
      :required-mark="false"
      style="margin-bottom: 8px"
    >
      <template #label>
        <text-with-mark :text="$t('转人工方式')" />
      </template>
      <t-space>
        <t-radio-group :value="formData.routePolicy" @change="onTypeChange">
          <t-radio value="0">{{ $t("直接转人工") }}</t-radio>
          <t-radio value="1">{{ $t("转至指定客服分组") }}</t-radio>
        </t-radio-group>
      </t-space>
    </t-form-item>
    <template v-if="formData.routePolicy === '1'">
      <t-form-item
        name="groupId"
        :required-mark="false"
        :rules="[
          {
            required: true,
            message: $t('不能为空'),
            trigger: 'change',
          },
        ]"
        style="margin-bottom: 12px"
      >
        <t-select v-model="formData.groupId" :options="skillGroup" filterable />
      </t-form-item>
      <div>
        <span style="color: #6d778c; padding-right: 8px">{{
          $t("“客服分组”如未配置，需前往“分组管理”进行配置")
        }}</span>

        <t-link theme="primary" hover="color" @click="openGroupConfig">{{
          $t("前往配置")
        }}</t-link>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { t } from "@/utils/i18n";
import { trim } from "lodash-es";
import { inject, reactive, Ref, toRefs, watch } from "vue";

type OptionType = Array<{ value: string; label: string }>;

const emit = defineEmits(["updateData"]);

const getGroupsFn = inject<Ref<() => Promise<OptionType>>>("getGroups");

type Model = {
  nodeData: {
    routePolicy: "0" | "1";
    groupId?: string;
  };
};

const props = defineProps<{
  data: Model["nodeData"];
  visible: boolean;
}>();

const formData = reactive<Model["nodeData"]>({
  routePolicy: props.data.routePolicy ?? "0",
  groupId: props.data.groupId ?? "",
});

const skillGroup = reactive<OptionType>([]);

const onTypeChange = (v) => {
  formData.routePolicy = v;
  formData.groupId = "";
};

const getOptions = () => {
  if (getGroupsFn?.value) {
    getGroupsFn.value().then((data) => {
      console.log("data", data);
      skillGroup.splice(0, skillGroup.length, ...data);
    });
  }
};

const openGroupConfig = () => {
  try {
    const paths = window.location.pathname.split("/");
    const href = ["", paths[1], paths[2], "manage/group"].join("/");
    window.open(href, "_blank");
  } catch (error) {
    return "";
  }
};

const requireRule = [
  {
    validator: (str) => {
      return !!trim(str);
    },
    message: t("不能为空"),
    trigger: "change",
  },
];

watch(formData, (newVal, oldVal) => {
  console.log("human====", newVal);
  emit("updateData", newVal);
});

const { visible } = toRefs(props);

watch(
  visible,
  (newVal) => {
    if (newVal) {
      getOptions();
    }
  },
  { immediate: true },
);
</script>
<style lang="less" scoped></style>
